import {
  EXECUTIVE_PERIOD_OPTIONS,
  EXECUTIVE_STATUS_OPTIONS,
  type ExecutiveFilterOption,
  type ExecutiveFiltersState,
} from '../../lib/executive-filters'
import { SearchableFilterField } from './SearchableFilterField'
import styles from './ExecutiveHeader.module.css'

interface ExecutiveHeaderProps {
  filters: ExecutiveFiltersState
  institutionOptions: ReadonlyArray<ExecutiveFilterOption<string>>
  campaignOptions: ReadonlyArray<ExecutiveFilterOption<string>>
  canShareAccess?: boolean
  onShareAccess?: () => void
  onPeriodChange: (value: string) => void
  onInstitutionChange: (value: string) => void
  onCampaignChange: (value: string) => void
  onStatusChange: (value: string) => void
}

export function ExecutiveHeader({
  filters,
  institutionOptions,
  campaignOptions,
  canShareAccess = false,
  onShareAccess,
  onPeriodChange,
  onInstitutionChange,
  onCampaignChange,
  onStatusChange,
}: ExecutiveHeaderProps) {
  return (
    <header className={styles.header}>
      <div className={styles.heading}>
        <h1 className={styles.title}>Visão Executiva</h1>
        {canShareAccess && onShareAccess ? (
          <button type="button" className={styles.shareButton} onClick={onShareAccess}>
            Compartilhar acesso
          </button>
        ) : null}
      </div>

      <div className={styles.filters} role="group" aria-label="Filtros da visão executiva">
        <SearchableFilterField
          id="executive-filter-period"
          label="Período"
          value={filters.period}
          options={EXECUTIVE_PERIOD_OPTIONS}
          onChange={onPeriodChange}
          searchPlaceholder="Buscar período..."
          emptyMessage="Nenhum período encontrado"
          icon="mdi:calendar-month-outline"
        />
        <SearchableFilterField
          id="executive-filter-institution"
          label="Instituição"
          value={filters.institution}
          options={institutionOptions}
          onChange={onInstitutionChange}
          searchPlaceholder="Buscar instituição..."
          emptyMessage="Nenhuma instituição encontrada"
        />
        <SearchableFilterField
          id="executive-filter-campaign"
          label="Campanha"
          value={filters.campaign}
          options={campaignOptions}
          onChange={onCampaignChange}
          searchPlaceholder="Buscar campanha..."
          emptyMessage="Nenhuma campanha encontrada"
        />
        <SearchableFilterField
          id="executive-filter-status"
          label="Status"
          value={filters.status}
          options={EXECUTIVE_STATUS_OPTIONS}
          onChange={onStatusChange}
          searchPlaceholder="Buscar status..."
          emptyMessage="Nenhum status encontrado"
        />
      </div>
    </header>
  )
}
